import React from "react"
import { Image } from "primereact/image"
import logo from "../assets/agencia-MD-logo.png"
import { auth } from "../firebase"
import { useLocation, Link } from "react-router-dom"
import ROUTES from "../router/routesConstants"

function Header() {
  const location = useLocation()
  const isHome = location.pathname === ROUTES.HOME

  return (
    <div className="header">
      {isHome ? (
        <Link to={ROUTES.HOME}>
          <i className="pi text-xl text-white" />
        </Link>
      ) : (
        <Link to={ROUTES.HOME}>
          <i className="pi pi-arrow-left text-xl text-white" />
        </Link>
      )}
      <Link to={ROUTES.HOME}>
        <Image className="text-center" src={logo} alt="Logo" />
      </Link>
      <Link to="#" onClick={async () => {
        // Push logout event to dataLayer
        window.dataLayer.push({
          event: 'logout'
        });
        await auth.signOut();
      }}>
        <i className="pi pi-sign-out text-xl text-white" />
      </Link>
    </div>
  )
}

export default Header
